<template>
  <div class="container-fluid p-0  mb-5">
      <notificationList></notificationList>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'
import notificationList from '@/components/notificationsList.vue'

export default {
  name: 'Notifications',
  components: {notificationList},
  data() {
    return {
      search_input: "",
    }
  },
  computed: { 
    ...mapGetters("user",{
      authorized: 'authorized',
    })  
  },
  mounted () {
    this.$store.commit('set_view_name', ['Notificaciones'])
  }, 
}
</script>

<style lang= "scss" scoped >
  .container-fluid{
    height: 100%;
    overflow: auto;
  }



</style>
